export default {
    name: 'Главная',
    city: 'Город',
    snip: 'Основания',
    statistics: 'Статистика',
    projectEmpty: 'Проекты отсутствуют',
    withoutSection: 'Без секций',
    projects: 'Проекты',
};
